// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../channels2022/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".recently-visited[data-v-4997baf6]{display:flex;flex-wrap:nowrap;overflow:auto}.recently-visited .nav-link[data-v-4997baf6]{white-space:nowrap}.custom-scroll[data-v-4997baf6]{overflow:auto}.custom-scroll[data-v-4997baf6]::-webkit-scrollbar{width:0;height:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
